import { Injector, StaticProvider } from '@angular/core';
import {
  ExportAclService,
  ExportGitService,
  ExportQuery,
  ExportService,
  ExportStore,
  ExportTriggerJobQuery,
  ExportTriggerJobService,
  ExportTriggerJobStore,
  ExportTriggerQuery,
  ExportTriggerService,
} from '@y42/data-export';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { ImpexServiceDef, provideImpex } from '@y42/impex';
import { JobServiceDef, provideJob } from '@y42/job';
import { Y42FeatureType } from '@y42/json-schema';
import { ExportTabs } from './export-tabs.constant';

const ExportFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.Export,
    GIT_FOLDER: Y42GitFolders.Export,
    FEATURE_ROUTE: Y42Routes.Export,
    DETAIL_TABS: ExportTabs,
    AbstractFeatureService: ExportService,
    AbstractFeatureQueryEntity: ExportQuery,
    AbstractFeatureEntityStore: ExportStore,
    AbstractFeatureGitService: ExportGitService,
    AbstractFeatureAclService: ExportAclService,
    AbstractFeatureChildQueryEntity: ExportTriggerQuery,
  };
};

const ExportJobProviders: () => JobServiceDef = () => {
  return {
    JobService: ExportTriggerJobService,
    JobStore: ExportTriggerJobStore,
    JobQuery: ExportTriggerJobQuery,
    JOB_OVERVIEW_MODELS: (injector: Injector) => injector.get(ExportQuery).activeTriggers$,
    ACTIVE_JOB_OVERVIEW_MODEL: (injector: Injector) => injector.get(ExportTriggerQuery).active$,
  };
};

const ExportImpexProviders: () => ImpexServiceDef = () => ({
  ImpexService: ExportService,
  ImpexChildService: ExportTriggerService,
  ImpexQuery: ExportQuery,
  ImpexChildQuery: ExportTriggerQuery,
});

export function ExportProviders(
  options: {
    feature: boolean;
    job: boolean;
    impex: boolean;
  } = {
    feature: true,
    job: true,
    impex: true,
  },
): StaticProvider[] {
  return [
    options.feature ? provideFeature(ExportFeatureProviders()) : [],
    options.job ? provideJob(ExportJobProviders()) : [],
    options.impex ? provideImpex(ExportImpexProviders()) : [],
  ];
}
